import { useEffect, useState } from "react";
import { ConfigProvider, Spin } from "antd";
import { useLocation } from "react-router-dom";

import Router from "./Routes/Routes";
import { checkClearLang } from "@utils/ManageLang";
import countryLangStore from "@zustand/countryLang";
import { ModalFailed } from "@components/Modal";
import { getConfigMaintenance } from "@api/master";
import configStore from "@zustand/configStore";
import MaintenanceService from "@pages/MaintenanceService";
import { colors } from "@constants/colors";
import CenteredModal from "@components/Modal/CenteredModal";

const App = () => {
  const location = useLocation();
  const [isAllowed, setIsAllowed] = useState<boolean | null>(null);

  const { lang, setLang } = countryLangStore();
  const { setConfigMaintenance } = configStore();

  useEffect(() => {
    if (checkClearLang(lang)) {
      setLang(process.env.REACT_APP_COUNTRY_LANG as string);
    }
  }, []);

  useEffect(() => {
    handleConfigMaintenance();
  }, [location?.pathname]);

  const handleConfigMaintenance = async () => {
    const { status, message } = await getConfigMaintenance(
      `role=user&name=["configMaintenance"]`,
    );
    if (status) {
      const response = message?.configMaintenance?.close_service;
      setIsAllowed(response?.open);
      setConfigMaintenance(response);
    } else {
      setIsAllowed(false);
    }
  };

  if (isAllowed === null) return <Spin size="large" className="loading" />;
  if (isAllowed) {
    return <MaintenanceService />;
  }
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "IBM Plex Sans Thai",
        },
        components: {
          Button: {
            colorPrimary: colors.greenb67,
            colorPrimaryHover: colors.green721,
            defaultHoverBg: "initial",
            defaultHoverColor: "initial",
          },
          Radio: {
            colorPrimary: colors.primary,
          },
          Checkbox: {
            colorPrimary: colors.primary,
          },
        },
      }}
    >
      <div className="App">
        <Router />
      </div>
      <ModalFailed />
      <CenteredModal />
    </ConfigProvider>
  );
};

export default App;
